module.exports = __webpack_public_path__ + "img/video1.1f5bd86d.jpg";